import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inviteandearn',
  templateUrl: './inviteandearn.component.html',
  styleUrls: ['./inviteandearn.component.css']
})
export class InviteandearnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
